import JemConfiguration from 'eflex/models/jem-configuration';

export default class CustomTabJemConfiguration extends JemConfiguration {}
